/*
 * Helper js provides set of function that are used for parsing data
 * @usage import {function-name} from 'helper.js'
 */
import {
  OUT_OF_STOCK,
  OUT_OF_STOCK_LEVELS,
  TIMEFORMAT,
} from '../util/Constants';
import { GO_TO_CHECKOUT } from '../util/urls';
import axios from 'axios';
import _lodash from 'lodash';
import alertify from 'alertifyjs';
import moment from 'moment';
import { get } from 'lodash';
import {
  getSelectedPizzaCreatorModifiers,
  calculatePizzaModifierBuilderCost,
} from '../views/dashboard/components/items/components/PizzaCreatorModifiers/utils';
const FORCED_MODIFIERS = 'FORCED';
const OPTIONAL_MODIFIERS = 'OPTIONAL';

/*
 * parsePrice formats comma-to-decimal/decimal-to-comma
 * @param price      the value of the item
 * @param formatted  default false . On false returns price to display / on true returns price that can be used for mathematical calculations
 */
export const parsePrice = (price, formatted, appendCurrency) => {
  const isNegativeNumber = parseFloat(price) < 0;
  formatted = formatted || false;
  if (!formatted) {
    price = Math.abs(price);
  }
  appendCurrency = appendCurrency === false ? false : true;
  let currencySymbolLeft = '',
    currencySymbolRight = '';
  let space = '';
  let commaDotPattern = price && price.toString().indexOf('.') !== -1;

  if (window.currencySymbolPosition === 'right' && appendCurrency) {
    currencySymbolRight = window.currencySymbol;
  } else if (appendCurrency) {
    currencySymbolLeft = window.currencySymbol;
  }

  if (!price) {
    return formatted
      ? parseFloat(0).toFixed(window.decimalPoints)
      : (
          currencySymbolLeft +
          space +
          parseFloat(0).toFixed(window.decimalPoints) +
          space +
          currencySymbolRight
        ).replace('.', window.decimalSeparator);
  }
  let formattedPrice = price;

  if (commaDotPattern) {
    if (price.toString().indexOf('.') < price.toString().indexOf(',')) {
      formattedPrice = parseFloat(
        price
          .toString()
          .replace('.', '')
          .replace(',', '.')
      ).toFixed(window.decimalPoints);
    } else {
      formattedPrice = parseFloat(price.toString().replace(',', '')).toFixed(
        window.decimalPoints
      );
    }
  }

  switch (window.decimalSeparator) {
    // when decimal separator is comma, remove dot and replace comma with a dot
    case ',':
      if (!commaDotPattern) {
        formattedPrice = parseFloat(price.toString().replace(',', '.')).toFixed(
          window.decimalPoints
        );
      }
      break;

    // when decimal separator is dot, remove just remove the comma Character from the string
    case '.': // the same is default case
    default:
      if (!commaDotPattern) {
        formattedPrice = parseFloat(price.toString().replace(',', '')).toFixed(
          window.decimalPoints
        );
      }
      break;
  }

  return formatted
    ? formattedPrice
    : (isNegativeNumber ? '-' : '') +
        currencySymbolLeft +
        space +
        number_format(
          formattedPrice,
          window.decimalPoints,
          window.decimalSeparator,
          window.decimalSeparator === ',' ? '.' : ','
        ) +
        space +
        currencySymbolRight;
};

export const getAlertifyHeader = (
  header,
  color = '#589e00',
  align = 'left'
) => {
  const headerColor = color === false || !color ? '#589e00' : color;
  return `<div style='color:${headerColor};text-align:${align}'>${header}</div>`;
};

export const getSelectedModifiers = forcedModData => {
  forcedModData.map((forcedMods, modIndex) => {
    forcedMods.ingredients = forcedMods.ingredients || '';
    forcedMods.title = forcedMods.title.trim();
    if (forcedMods.option.length > 0) {
      forcedMods.option.map((modifiers, index) => {
        modifiers.title = modifiers.title.trim();
        modifiers.ingredients =
          modifiers.ingredients === null ? '' : modifiers.ingredients;
        if (modifiers.doption && modifiers.doption.length > 0) {
          getSelectedModifiers(modifiers.doption);
        }
      });
    }
  });
};

export const setCheckout = (object, strict, callBack) => {
  strict = strict === false ? false : true;
  let orderItems =
    object.props.orderItems || object.props.dashboardData.orderItemsList;
  if (orderItems.length < 1 && strict) {
    alertify.alert(
      getAlertifyHeader(
        JSON.parse(localStorage.getItem('langVars'))['error'],
        'red'
      ),
      JSON.parse(localStorage.getItem('langVars'))['pleaseAddItemToCart']
    );
  } else if (orderItems.length > 0) {
    let orderPanelApiObj = GetCartItems(orderItems, object.addDataDoption);
    let modeOfOrder = _lodash.get(object, 'props.dashboardData.modeOfOrder');
    let items_object = _lodash.get(
      object,
      'props.dashboardData.orderItemsList'
    );
    items_object.map((valueOption, keyOption) => {
      delete valueOption.intl;
      delete valueOption.isItemInBag;
      delete valueOption.basePrice;
      delete valueOption.baseNutrition;
      delete valueOption.numberOfItems;
    });

    items_object.map((forcedItems, key) => {
      forcedItems.forced.map((forcedOpt, optIndex) => {
        forcedOpt.option.map((forcedItems, key) => {
          forcedItems.ingredients = forcedItems.ingredients || '';
          forcedItems.title = forcedItems.title.trim();
          if (forcedItems.doption && forcedItems.doption.length > 0) {
            getSelectedModifiers(forcedItems.doption);
          }
        });
      });
    });

    // items_object.map((forcedItems, key) => {
    //   forcedItems.forced.map((forcedOpt, optIndex) => {
    //     forcedOpt.name;
    //     forcedOpt.option.map((forcedItems, key) => {
    //       forcedItems.ingredients = forcedItems.ingredients === null?"":forcedItems.ingredients
    //       forcedItems.title =  forcedItems.title.trim();
    //       if (forcedItems.doption && forcedItems.doption.length > 0) {
    //         getSelectedModifiers(forcedItems.doption);
    //       }
    //     });
    //   });
    // });

    // console.log('items_obj', JSON.parse(JSON.stringify(items_object)));
    //----------------------------------------------------------------------------------

    let deliveryFees = _lodash.get(
      object,
      'props.dashboardData.locationDetails.delivery_fees',
      0
    );
    const orderId = _lodash.get(
      object,
      'props.dashboardData.orderIdDetails.order_id',
      ''
    );
    let languageid = localStorage.getItem('language') || '1';
    let postData = {
      dataname: object.props.dashboardData.dataName,
      cart_contents: JSON.stringify(orderPanelApiObj),
      order_id: orderId,
      user_id: object.props.loginUserDetails
        ? object.props.loginUserDetails.id
        : 0,
      order_type: GetOrderType(object.props.dashboardData.modeOfOrder),
      delivery_fee: modeOfOrder === 2 ? deliveryFees : 0,
      open_date: moment().format('YYYY-MM-DD HH:mm:ss'),
      locationid: object.props.dashboardData.merchantDetails.locationid,
      languageid: languageid,
    };

    let config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + btoa(object.props.jwt),
      },
    };

    return axios
      .post(
        GO_TO_CHECKOUT + 'tokenId/' + object.props.tokenId,
        postData,
        config
      )
      .then(function(response) {
        let res = response;
        if (
          res.data.DataResponse &&
          res.data.DataResponse.status &&
          res.data.DataResponse.status.toLowerCase() === 'f'
        ) {
          alertify.alert(
            getAlertifyHeader(
              JSON.parse(localStorage.getItem('langVars'))['error'],
              'red'
            ),
            res.data.DataResponse.msg
          );
          return false;
        } else {
          if (callBack) {
            callBack(res.data.DataResponse);
          }
        }
      });
  }
};

export const GetTaxes = (props, response, item, cartContents) => {
  let taxDetails = [];
  if (
    props.dashboardData &&
    props.dashboardData.itemTaxes &&
    props.dashboardData.itemTaxes.taxdetails &&
    props.dashboardData.itemTaxes.taxdetails.length > 0
  ) {
    taxDetails = props.dashboardData.itemTaxes.taxdetails;
  }
  if (response.taxdetails.length > 0) {
    response.taxdetails.forEach(responseTax => {
      if (!responseTax.itemId) {
        responseTax.itemId = item.id;
      }

      if (taxDetails.length < 1) {
        taxDetails = response.taxdetails;
      } else {
        let pushTax = true;
        taxDetails.forEach((currentItemTax, i) => {
          if (
            responseTax.type === currentItemTax.type &&
            responseTax.itemId === currentItemTax.itemId
          ) {
            taxDetails[i] = responseTax;
            pushTax = false;
            return false;
          }
          if (cartContents) {
            let exsist = false;
            cartContents.forEach((cartItem, itemKey) => {
              if (cartItem.itemid === currentItemTax.itemId) {
                exsist = true;
              }
            });
            if (!exsist) {
              taxDetails.splice(i, 1);
            }
          }
        });
        if (pushTax) {
          taxDetails.push(responseTax);
        }
      }
    });
  }
  return taxDetails;
};

export const SplitTax = taxesDetails => {
  let splitTax = {
    inclusiveTaxes: [],
    exclusiveTaxes: [],
  };

  if (!taxesDetails) return splitTax;

  Object.keys(taxesDetails).forEach(function(key) {
    Object.keys(taxesDetails[key]).forEach(function(taxId) {
      Object.keys(taxesDetails[key][taxId]).forEach(function(groupId) {
        let taxes = taxesDetails[key][taxId][groupId];
        let { calculatedTaxAmount } = taxes;
        if (
          calculatedTaxAmount &&
          calculatedTaxAmount.toString().replace(/[0\.,\t\s]/g, '').length > 0
        ) {
          taxes['formattedTitle'] =
            taxes.title +
            ' ( ' +
            taxes.rate +
            ' of ' +
            parsePrice(taxes.subtotal) +
            ' )';
          switch (key) {
            case 'included':
              splitTax.inclusiveTaxes.push(taxes);
              break;
            case 'excluded':
              splitTax.exclusiveTaxes.push(taxes);
              break;
          }
        }
      });
    });
  });

  return splitTax;
};

export const isItemOrModifierInStock = item => {
  return (
    item.availability !== OUT_OF_STOCK &&
    !_lodash.includes(OUT_OF_STOCK_LEVELS, item.notavailable)
  );
};

export const cookieValue = name => {
  function escape(s) {
    return s.replace(/([.*+?${}()|\[\]\/\\])/g, '\\$1');
  }
  var match = document.cookie.match(
    RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)')
  );
  return match ? match[1] : null;
};

export const getCartPriceDetails = (cartDetails, addTip) => {
  const cartItems =
    cartDetails.orderItems || cartDetails.dashboardData.orderItemsList;
  const decimalPoint = window.decimalPoints;
  const merchantDetails = _lodash.get(
    cartDetails,
    'dashboardData.merchantDetails',
    {}
  );
  let cartPriceSplit = {
    subTotal: 0,
    deliveryFee: parseFloat(
      parsePrice(cartDetails.dashboardData.locationDetails.delivery_fees, true)
    ),
    inclusiveTaxes: [],
    exclusiveTaxes: [],
    discountDetails: false,
    decimalPoint: decimalPoint,
    grandTotal: 0,
    tip: {
      formatted: parseFloat(cartDetails.dashboardData.tipPrice),
      price: cartDetails.dashboardData.tipPrice,
      percent: cartDetails.dashboardData.tipPercent,
      type: cartDetails.dashboardData.tipType,
    },
    decimal_separator: merchantDetails.decimal_separator,
    total: 0,
    roundingAmount: 0,
  };

  if (cartDetails.discount) {
    cartPriceSplit['discountDetails'] = cartDetails.discount;
  } else if (cartDetails.checkoutData && cartDetails.checkoutData.discount) {
    cartPriceSplit['discountDetails'] = cartDetails.checkoutData.discount;
  }

  if (!cartItems || (cartItems && cartItems.length < 1)) return cartPriceSplit;

  cartItems.forEach(item => {
    if (item && isItemOrModifierInStock(item)) {
      cartPriceSplit.subTotal =
        parseFloat(parsePrice(cartPriceSplit.subTotal, true)) +
        parseFloat(parsePrice(item.price, true));
    }
  });
  cartPriceSplit.grandTotal = cartPriceSplit.subTotal;

  if (
    cartDetails.dashboardData &&
    cartDetails.dashboardData.itemTaxes &&
    cartDetails.dashboardData.itemTaxes.taxdetails &&
    Object.keys(cartDetails.dashboardData.itemTaxes.taxdetails).length > 0
  ) {
    const taxesDetails = cartDetails.dashboardData.itemTaxes.taxdetails;
    Object.keys(taxesDetails).forEach(function(key) {
      Object.keys(taxesDetails[key]).forEach(function(taxId) {
        Object.keys(taxesDetails[key][taxId]).forEach(function(groupId) {
          let taxes = taxesDetails[key][taxId][groupId];
          let { calculatedtaxamount } = taxes;
          if (
            calculatedtaxamount &&
            calculatedtaxamount.toString().replace(/[0\.,\t\s]/g, '').length > 0
          ) {
            if (taxes) {
              taxes['formattedTitle'] =
                taxes.title +
                ' ( ' +
                taxes.rate +
                ' of ' +
                parsePrice(taxes.subtotal) +
                ' )';
              switch (taxes.type) {
                case 'itax':
                  cartPriceSplit.inclusiveTaxes.push(taxes);
                  break;
                case 'etax':
                  cartPriceSplit.exclusiveTaxes.push(taxes);
                  cartPriceSplit.grandTotal += parseFloat(
                    parsePrice(taxes.calculatedtaxamount, true)
                  );
                  break;
              }
            }
          }
        });
      });
    });
  }

  if (Number(cartDetails.dashboardData.modeOfOrder) === 2)
    cartPriceSplit.grandTotal += parseFloat(
      parsePrice(cartDetails.dashboardData.locationDetails.delivery_fees, true)
    );

  cartPriceSplit.grandTotal = parseFloat(
    parsePrice(cartPriceSplit.grandTotal, true)
  );

  cartPriceSplit.grandTotal += cartPriceSplit.roundingAmount;
  cartPriceSplit.total = cartPriceSplit.grandTotal;

  if (
    cartPriceSplit.discountDetails.discount_value &&
    cartPriceSplit.discountDetails.computeInCartTotal
  ) {
    cartPriceSplit.grandTotal -= parseFloat(
      parsePrice(cartPriceSplit.discountDetails.discount_value, true)
    );
    cartPriceSplit.grandTotal = parseFloat(
      parsePrice(cartPriceSplit.grandTotal, true)
    );
  }

  cartPriceSplit.tip.price = tipCalculator(
    cartPriceSplit.tip,
    cartPriceSplit.grandTotal
  );

  cartPriceSplit.grandTotal += parseFloat(
    parsePrice(cartPriceSplit.tip.price, true)
  );

  cartPriceSplit.subTotal = parseFloat(
    parsePrice(cartPriceSplit.subTotal, true)
  );

  const forcedRounding = roundingAdjustment(
    cartPriceSplit.grandTotal,
    merchantDetails.round_up_or_down,
    parseFloat(merchantDetails.rounding_factor)
  );

  if (forcedRounding.roundingAmount !== 0) {
    cartPriceSplit.grandTotal = forcedRounding.amount;
    cartPriceSplit.roundingAmount = forcedRounding.roundingAmount;
  }
  return cartPriceSplit;
};

export const tipCalculator = (tipDetails, tipOn) => {
  if (!tipOn) return 0;
  switch (tipDetails.type.toLowerCase()) {
    case 'p':
      return (
        parseFloat(parsePrice(tipOn, true)) *
        (parseFloat(parsePrice(tipDetails.percent, true)) / 100)
      );
    case 'c':
      return parseFloat(parsePrice(tipDetails.price, true));
    default:
      return 0;
  }
};

export const checkLocationRoute = (props, nextProps) => {
  const currentRoute = nextProps
    ? nextProps.location.pathname.split('/')[1].toLowerCase()
    : props.location.pathname.split('/')[1].toLowerCase();
  let previousRoute = props.dashboardData.previousRoute;
  previousRoute = previousRoute !== false ? previousRoute.toLowerCase() : false;
  const isLocationChange = props.dashboardData.locationChanged;
  let route = false;
  if (
    previousRoute !== false &&
    currentRoute !== previousRoute &&
    !isLocationChange
  ) {
    route = true;
  }

  return {
    status: route,
    currentRoute: currentRoute,
    previousRoute: previousRoute,
  };
};

export const filterModifierForCheckout = (modifierList, list, type) => {
  console.log('modifiers list', modifierList);
  if (modifierList) {
    return new Promise((resolve, reject) => {
      modifierList.map((data, key) => {
        if (data.option && data.option.length > 0) {
          data.option.map((optionData, optionKey) => {
            switch (type) {
              case OPTIONAL_MODIFIERS:
                list.omods.push(optionData.id);
                if (modifierList.isChecked === true) {
                  list.omods_checked.push(data.id);
                }
                break;
              default:
                list.fmods.push(optionData.id);
                if (modifierList.isChecked === true) {
                  list.fmods_checked.push(data.id);
                }
                break;
            }
          });
          filterModifierForCheckout(data.option, list, type);
        } else {
          if (data.isChecked) {
            switch (type) {
              case OPTIONAL_MODIFIERS:
                list.omods_checked.push(data.id);
                break;
              default:
                list.fmods_checked.push(data.id);
                break;
            }

            if (data.doption && data.doption.length > 0) {
              filterModifierForCheckout(data.doption, list, type);
            }
          }
        }
      });
      resolve(modifierList);
    });
  }
};

export const GetCartItems = cartItems => {
  let items = [];
  let reOrderObj = {};
  cartItems.forEach((item, index) => {
    if (isItemOrModifierInStock(item)) {
      let itemObj = {
        itemid: item.id,
        qty: 1,
        fmods_checked: [],
        omods_checked: [],
        fmods: [],
        omods: [],
        special: item.specialInstruction,
        notes: item.specialInstruction,
        use_pizza_creator: false,
        mods_builder_content: {},
      };

      itemObj.use_pizza_creator = item.use_pizza_creator;
      if (item.use_pizza_creator) {
        const selectedModifiers = getSelectedPizzaCreatorModifiers(
          item.pizza_creator.pizza_mods
        );
        selectedModifiers.forEach(selectedModifier => {
          itemObj.fmods_checked.push(selectedModifier.id);
          if (selectedModifier.use_builder) {
            itemObj.mods_builder_content[selectedModifier.id] = {
              amount: selectedModifier.selected_amount.id,
              serving: selectedModifier.selected_serving.id,
              cost: calculatePizzaModifierBuilderCost(
                selectedModifier.cost,
                selectedModifier.selected_amount,
                selectedModifier.selected_serving
              ),
            };
          }
        });
      } else {
        if (item.forced || item.order_contents_information.length > 0) {
          filterModifierForCheckout(
            item.forced || item.order_contents_information[0].forced,
            itemObj,
            FORCED_MODIFIERS
          );
        }
        if (item.optional || item.order_contents_information.length > 0) {
          filterModifierForCheckout(
            item.optional || item.order_contents_information[0].optional,
            itemObj,
            OPTIONAL_MODIFIERS
          );
        }
      }
      items.push(itemObj);
    }
  });
  return items;
};

export const GetOrderType = (orderType, messages, defaultType) => {
  const orderTypes = messages || {
    pickup: 'Pickup',
    dine_in: 'Dine-in',
    delivery: 'Delivery',
  };
  defaultType = defaultType || false;
  switch (parseInt(orderType)) {
    case 1:
      return orderTypes.pickup;
    case 2:
      return orderTypes.delivery;
    case 3:
      return orderTypes.dine_in;
    default:
      return defaultType ? orderTypes.pickup : false;
  }
};

export const NutritionStringToObject = (nutrition, modifier, equation) => {
  let nutritionList = [];
  let nutritionToObject = olo.toNutritionObject(nutrition);

  if (modifier && modifier.nutrition) {
    modifier = modifier.nutrition;
  }

  let modifierToObject = olo.toNutritionObject(modifier);

  if (nutritionToObject.length === 0 && modifierToObject.length > 0) {
    nutritionList = modifierToObject;
  } else {
    if (modifierToObject.length > 0) {
      nutritionList = JSON.parse(JSON.stringify(nutritionToObject));
      for (let m = 0; m < modifierToObject.length; m++) {
        let hasValue = _lodash.findKey(nutritionList, function(n) {
          return (
            n.name.toLowerCase() === modifierToObject[m].name.toLowerCase()
          );
        });
        if (hasValue) {
          nutritionList[hasValue].value = olo.resolveEquation(
            [nutritionList[hasValue].value, modifierToObject[m].value],
            equation
          );
        } else {
          nutritionList.push({
            name: modifierToObject[m].name,
            value: modifierToObject[m].value,
            unit: modifierToObject[m].unit,
          });
        }
      }
    } else if (nutritionToObject.length > 0) {
      nutritionList = JSON.parse(JSON.stringify(nutritionToObject));
    }
  }

  return nutritionList;
};

export const olo = {
  toNutritionObject: param => {
    if (param && typeof param === 'string' && param.replace(/\s/g, '')) {
      let list = [];
      const nutritionItems = param.split(',');

      for (let i = 0; i < nutritionItems.length; i++) {
        let nutritionInfo = nutritionItems[i].split(' - ');
        let nutritionValue = Number(nutritionInfo[1]);
        if (nutritionInfo.length >= 3) {
          list.push({
            name: nutritionInfo[0],
            value: nutritionValue,
            unit: nutritionInfo[2],
          });
        }
      }

      return list;
    } else {
      return param && param.length > 0 ? param : [];
    }
  },
  /*
   * nutrition resolve equation judge to plus or minus
   */
  resolveEquation: function(values, equation) {
    equation = equation || 'plus';

    switch (equation) {
      case 'plus':
        return Number(values[0]) + Number(values[1]);
      case 'minus':
        return Number(values[0]) - Number(values[1]);
      default:
        return 0;
    }
  },

  /*
   * split nutrition string to object
   * @example string calories - 100 - g,fat - 100 - mg,proteins - 200 - mg,sodium - 100 - g,sugar - 50 - mg,carbs - 75 - g,saturated_fat - 50 - g,fiber - 150 - mg
   * @return [ {'name' : 'nutrition-name', 'value' : 'value in number', 'unit' : 'unit of measurement'} ,{...},{...}]
   */
  getNutritionFromString: function(nutritionString, name) {
    let valueOf = 0;

    const lookForName = name ? name.toLowerCase() : false;

    switch (typeof nutritionString) {
      case 'string':
        const data = nutritionString.split(',');
        for (let i = 0; i < data.length; i++) {
          let nutritionInfo = data[i].split(' - ');
          let ingredentName = nutritionInfo[0] || '';

          if (
            lookForName !== false &&
            ingredentName.toLowerCase() === lookForName
          ) {
            valueOf = Number(nutritionInfo[1]);
          }
        }
        break;

      default:
        if (nutritionString !== undefined) {
          for (let i = 0; i < nutritionString.length; i++) {
            let ingredentName = nutritionString[i].name || '';

            if (
              lookForName !== false &&
              ingredentName.toLowerCase() === lookForName &&
              !isNaN(nutritionString[i].value)
            ) {
              valueOf = Number(nutritionString[i].value);
            }
          }
        }
        break;
    }

    return valueOf;
  },
};

export const number_format = (number, decimals, decPoint, thousandsSep) => {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  const n = !isFinite(+number) ? 0 : +number;
  const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  const sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
  const dec = typeof decPoint === 'undefined' ? '.' : decPoint;
  let s = '';
  const toFixedFix = function(n, prec) {
    let k = Math.pow(10, prec);
    return '' + (Math.round(n * k) / k).toFixed(prec);
  };
  // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
};

export const API_ERROR = (error, api) => {
  console.log('Failed to load API : ' + api + ' : ' + error);
};

export const getNutritionHeader = nutrition => {
  let header = [];
  if (Object.keys(nutrition).length > 0) {
    for (let i = 0, counter = 0; i < Object.keys(nutrition).length; i++) {
      if (nutrition[i].value !== 'NaN') {
        header.push(
          nutrition[i].value + ' ' + nutrition[i].unit + ' ' + nutrition[i].name
        );
        counter++;
      }

      if (counter === 2) {
        break;
      }
    }
  }

  return header.join(' | ');
};

export const minutesToString = (minuteCount, requireObject) => {
  const time = {
    hours: 0,
    minutes: 0,
    isHourSet: false,
    isMinutesSet: false,
    minuteCount,
    requireObject,
    timeString: '',
    splitTime: function() {
      this.hours = leftPad(Math.floor(Math.abs(this.minuteCount) / 60));
      this.minutes = leftPad(Math.abs(this.minuteCount) % 60);
      this.isHourSet = Number(this.hours) > 0;
      this.isMinutesSet = Number(this.minutes) > 0;

      if (this.isHourSet && this.isMinutesSet) {
        this.timeString = `${this.hours} hrs ${this.minutes} min`;
      } else if (this.isHourSet) {
        this.minutes = 0;
        this.timeString = this.hours + ' hrs';
      } else if (this.isMinutesSet) {
        this.hours = 0;
        this.timeString = this.minutes + ' min';
      }
    },
    getTimeString: function() {
      return this.timeString;
    },
    getTimeObject: function() {
      return { hours: this.hours, minutes: this.minutes };
    },
    getTime: function() {
      this.splitTime();
      return this.requireObject ? this.getTimeObject() : this.getTimeString();
    },
  };

  return time.getTime();
};

export const leftPad = number => {
  return (number < 10 && number >= 0 ? '0' : '') + number;
};

export const createModifierPath = (modifier, path) => {
  let isCaptionSet = _lodash.get(modifier, '0.title', false);
  if (isCaptionSet === false) {
    modifier = _lodash.get(modifier, '0.option', false);
  }
  if (modifier) {
    modifier.map((data, key) => {
      modifier[key]['group'] = path;
      let createdPath = path ? path + '.' + key : key;
      modifier[key]['modifierPath'] = createdPath;

      if (data.option && data.option.length > 0) {
        modifier[key]['option'] = createModifierPath(
          data['option'],
          createdPath + '.option'
        );
      }
      if (data.doption && data.doption) {
        modifier[key]['doption'] = createModifierPath(
          data['doption'],
          createdPath + '.doption'
        );
      }
      return modifier;
    });
  }
  return modifier;
};

export const formattedAddress = data => {
  const address = _lodash.isEmpty(data.address) ? '' : data.address + ',';
  const city = _lodash.isEmpty(data.city) ? '' : data.city + ',';
  const state = _lodash.isEmpty(data.state) ? '' : data.state + ',';
  const zip = _lodash.isEmpty(data.zip) ? '' : data.zip;
  return `${address} ${city} ${state} ${data.country} - ${zip}`;
};

export const addressToString = data => {
  let addressOne = !_lodash.isEmpty(data['address_1']) ? data['address_1'] : '';
  let addressTow = !_lodash.isEmpty(data['address_2'])
    ? (addressOne ? ', ' : '') + data['address_2']
    : '';
  let city = !_lodash.isEmpty(data.city) ? data.city + ',' : '';
  let state = !_lodash.isEmpty(data.state) ? data.state + ', ' : '';
  let country = !_lodash.isEmpty(data.country) ? data.country + ',' : '';
  let zipCode = !_lodash.isEmpty(data.zipcode) ? data.zipcode : '';

  return `${addressOne}${addressTow} ${city} ${state} ${country} ${zipCode}`;
};

export const splitGoogleAddressComponents = addressComponents => {
  let addressDetails = {
    postalCode: '',
    city: '',
    state: '',
    country: '',
    locality: '',
    administratorLevel: '',
    streetAddress: '',
    countryShortName: '',
    stateShortName: '',
    zipCode: '',
  };
  let keepAdding = true;
  if (addressComponents && addressComponents.length) {
    addressComponents.map(component => {
      let separator =
        component.types.includes('route') ||
        component.types.includes('street_number')
          ? ' '
          : addressDetails.streetAddress
            ? ', '
            : '';

      if (component.types.includes('postal_code')) {
        addressDetails.postalCode = component['long_name'];
        addressDetails.zipCode = component['long_name'];
        keepAdding = false;
      } else if (component.types.includes('locality')) {
        addressDetails.locality = component['long_name'];
      } else if (component.types.includes('administrative_area_level_1')) {
        addressDetails.state = component['long_name'];
        addressDetails.stateShortName = component['short_name'];
      } else if (component.types.includes('country')) {
        addressDetails.country = component['long_name'];
        addressDetails.countryShortName = component['short_name'];
      } else if (component.types.includes('administrative_area_level_2')) {
        addressDetails.administratorLevel = component.long_name;
      } else {
        if (keepAdding) {
          addressDetails.streetAddress += separator + component['long_name'];
        }
      }
      return addressDetails;
    });

    addressDetails.city =
      addressDetails.locality || addressDetails.administratorLevel;
  }

  return addressDetails;
};

export const roundingAdjustment = (amount, type, roundingFactor) => {
  const roundingDetails = {
    amount: amount,
    roundingAmount: 0,
  };

  if (roundingFactor) {
    let actualAmount = parseFloat(amount);
    let roundFactor = parseFloat(roundingFactor);
    let remainder = parseFloat(actualAmount % roundFactor);
    let roundNumber = parseFloat(
      parsePrice(Math.abs(remainder - roundFactor), true)
    );
    if (remainder > 0 && roundNumber > 0) {
      switch (type.toLowerCase()) {
        case 'up':
          roundingDetails.amount = actualAmount + roundNumber;
          roundingDetails.roundingAmount = roundNumber;
          break;

        case 'down':
          roundingDetails.amount = actualAmount - remainder;
          roundingDetails.roundingAmount = -Math.abs(remainder);
          break;

        default:
          if (remainder > roundNumber / 2) {
            roundingDetails.amount = actualAmount + roundNumber;
            roundingDetails.roundingAmount = Math.abs(roundNumber);
          } else {
            roundingDetails.amount = actualAmount - remainder;
            roundingDetails.roundingAmount = -Math.abs(remainder);
          }
          break;
      }
    }
  }
  return roundingDetails;
};

export const groupBy = (xs, key) => {
  return xs.reduce(function(rv, x) {
    (rv[get(x, key, {})] = rv[get(x, key, {})] || []).push(x);
    return rv;
  }, {});
};

export const addDeliveryAndTip = (totalAmount, tipAmount) => {
  const tip =
    tipAmount.toString().replace(/[0\.,\t\s]/g, '').length > 0 ? tipAmount : 0;
  return parsePrice(
    parseFloat(parsePrice(totalAmount, true)) +
      parseFloat(parsePrice(tip, true))
  );
};

export const isRestaurantAvailable = (
  weekConfiguration,
  datetime = moment(),
  onlyAfterGivenTime = false
) => {
  const dayMap = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
  };
  // Get Day
  const day = dayMap[datetime.get('day')];
  const time = moment(datetime.format(TIMEFORMAT), TIMEFORMAT);

  const openTimings = weekConfiguration[day] || [];

  return openTimings.some(duration => {
    const startTime = moment(duration.starttime, TIMEFORMAT);
    const endTime = moment(duration.endtime, TIMEFORMAT);
    return onlyAfterGivenTime
      ? time.isBefore(endTime)
      : time.isBetween(startTime, endTime);
  });
};

export const isAvailableNow = unavailableUntil => {
  if (!_lodash.isNumber(unavailableUntil)) {
    return undefined;
  }
  const time = moment(unavailableUntil * 1000);
  return moment().isAfter(time);
};



// WEBPACK FOOTER //
// ./src/lib/helper.js